import { __rest } from '../../../common/temp/node_modules/.pnpm/tslib@2.4.1/node_modules/tslib/tslib.es6.js';
import { spacing } from '../../../tokens/tokens-base/properties/build/js/index.js';
import cjs from '../../../common/temp/node_modules/.pnpm/deepmerge@4.2.2/node_modules/deepmerge/dist/cjs.js';
import { paramCase } from '../../../common/temp/node_modules/.pnpm/param-case@3.0.4/node_modules/param-case/dist.es2015/index.js';
import { ENABLED_STYLE_PROPS } from './styleProps.constants.js';

/**
 * The function that returns the value of the "spacing token" based on the category and name
 */
const getSpacing = (spacingCategory, spacingName) => {
  var _a;
  return (_a = spacing === null || spacing === void 0 ? void 0 : spacing[spacingCategory]) === null || _a === void 0 ? void 0 : _a[spacingName];
};
/**
 * The function that parses the value of the argument and returns the respective token or empty string
 */
const parseSpacingTokensToValue = token => {
  const tokenParamCase = paramCase(token);
  const [category, value] = tokenParamCase.split('-');
  if (!value) {
    console.error(`${token} is wrong. Use "layout" or "inner" as prefix. Example: "innerBase02", "layoutBase02"`);
    return '';
  }
  const spacingValue = getSpacing(category, value);
  if (spacingValue) {
    return spacingValue;
  }
  console.error(`Not found the "${token}" spacing token`);
  return '';
};
/**
 * The function that groups values into style props or props based enabled style props.
 */
const aggregateByStyleProps = props => (group, key) => {
  if (ENABLED_STYLE_PROPS.includes(key)) {
    return Object.assign(Object.assign({}, group), {
      styleProps: Object.assign(Object.assign({}, group.styleProps), {
        [key]: props[key]
      })
    });
  }
  return Object.assign(Object.assign({}, group), {
    props: Object.assign(Object.assign({}, group.props), {
      [key]: props[key]
    })
  });
};
/**
 * The builder function to create object with style props and props.
 */
const buildPropsGroup = props => {
  return Object.keys(props).reduce(aggregateByStyleProps(props), {
    styleProps: {},
    props: {}
  });
};
/**
 * The builder function to create object with media queries and their respective values as stitches approach
 */
const buildCssForBreakpoint = (breakpoint, css) => {
  return {
    [`@${breakpoint}Min`]: css
  };
};
/**
 * The builder function to generate CSS values to be used in the properties builder function
 */
const buildUtilsCssCode = (key, code) => {
  if (!code) {
    return {};
  }
  if (typeof code === 'string') {
    return {
      [key]: code
    };
  }
  return Object.keys(code).reduce((obj, codeKey) => {
    return Object.assign(Object.assign({}, obj), buildCssForBreakpoint(codeKey, {
      [key]: code[codeKey]
    }));
  }, {});
};
/**
 * The builder function to generate and merge CSS rules from the style props
 */
const buildCss = props => {
  return Object.keys(props).reduce((acc, key) => {
    return cjs(acc, buildUtilsCssCode(key, props[key]));
  }, {});
};
/**
 * The function that parses and splits css expression to call parseSpacingTokensToValue
 */
const parseSpacingTokensToStyleProps = value => {
  const tokensArray = value.split(' ');
  return tokensArray.map(token => {
    if (token === 'auto') {
      return token;
    }
    return parseSpacingTokensToValue(token);
  }).join(' ');
};
/**
 * The builder function that creates css rule from breakpoints
 */
const buildMediaQueryStyleProps = props => {
  return Object.keys(props).reduce((acc, subKey) => {
    var _a;
    return Object.assign(Object.assign({}, acc), {
      [subKey]: parseSpacingTokensToStyleProps((_a = props === null || props === void 0 ? void 0 : props[subKey]) !== null && _a !== void 0 ? _a : '')
    });
  }, {});
};
/**
 * The builder function to generate css property with CSS rules based from style props and rest properties
 */
const buildStyleProps = props => {
  const {
      css = {}
    } = props,
    restProps = __rest(props, ["css"]);
  const {
    styleProps: stylePropsKeys,
    props: otherProps
  } = buildPropsGroup(restProps);
  const styleProps = {};
  Object.keys(stylePropsKeys).forEach(key => {
    const currentProps = stylePropsKeys[key];
    if (!currentProps) {
      return;
    }
    // Example Input: { m: 'layoutBase' }
    if (typeof currentProps === 'string') {
      // Example Output: { m: '8px' }
      styleProps[key] = parseSpacingTokensToStyleProps(currentProps !== null && currentProps !== void 0 ? currentProps : '');
    }
    // Example Input: { m: { xs: 'layoutBase', md: 'layoytBase02' } }
    if (typeof currentProps === 'object') {
      // Example Output: { m: { xs: '8px', md: '16px' } }
      styleProps[key] = buildMediaQueryStyleProps(currentProps);
    }
  });
  return Object.assign({
    css: Object.assign(Object.assign({}, css), buildCss(styleProps))
  }, otherProps);
};
export { buildCss, buildCssForBreakpoint, buildPropsGroup, buildStyleProps, buildUtilsCssCode, getSpacing, parseSpacingTokensToStyleProps, parseSpacingTokensToValue };